import Text from "ab-text";

import "./ab-historia.scss";

const Historia = ({
  title = "Nuestra historia",
  subtitle = "descubre nuestro legado",
  content,
}) => {
  return (
    <div className="ab-historia">
      <Text element="h2">{title}</Text>
      <Text element="span" className="title">
        {subtitle}
      </Text>

      {content ? (
        <div dangerouslySetInnerHTML={{ __html: content }} />
      ) : (
        <>
          <Text>
            La Abadía de Santa María de Retuerta fue fundada a finales del siglo
            XII, a orillas del río Duero (en el término municipal de Sardón de
            Duero), y ha permanecido como testigo dentro de los límites de la
            finca Retuerta. Se trata de una de las obras más importantes del
            románico en la provincia de Valladolid. Su fundación data del año
            1146 por parte de Sancho Ansúrez, primer abad y descendiente del
            Conde Pedro Ansúrez, fundador a su vez de la villa de Valladolid.
          </Text>
          <Text>
            Fue la Orden Premostratense, en la que Sancho Ansúrez estaba
            ordenado como canónigo, la encargada de establecerse en Retuerta,
            constituyéndose como casa–madre de la orden en España.
          </Text>

          <img src="/images/descubra-1.png" />

          <Text>
            Desde sus orígenes, el monasterio de Santa María de Retuerta contó
            con el apoyo de la monarquía, pontífices y particulares, y es en
            este monasterio donde se celebraron los Capítulos Generales de la
            orden. Además, a partir del siglo XVII se convierte en Noviciado
            General de la orden en España.
          </Text>

          <Text>
            Los diversos documentos encontrados colocan a estas tierras como una
            explotación antiquísima y con gran arraigo y tradición en el cultivo
            de la vid, alrededor de la Abadía Santa María de Retuerta. Todo ello
            refuerza el gran potencial turístico de la zona al combinarse el
            interés cultural de los grandes edificios históricos con el
            atractivo de los vinos de calidad.
          </Text>

          <img src="/images/descubra-2.png" />

          <Text>
            La Desamortización de Mendizábal en 1835 determinaría la expulsión
            de los monjes del monasterio. Pasó entonces a manos del Estado,
            quien lo cedió a diferentes empresas y particulares hasta que en
            1988 la finca pasó a ser propiedad del Grupo Novartis, que con todo
            su empeño ha retomado exitosamente su ancestral actividad
            vitivinícola, ahora a través de la Bodega Abadía Retuerta, y hoy
            Abadia Retuerta Le Domaine.
          </Text>

          <Text>
            Consta de estilos arquitectónicos muy diferenciados: tardorrománico
            y gótico con elementos de los siglos XVI, XVII y XVIII. Si el
            patrimonio se ha salvado en muchos lugares gracias a iniciativas
            eclesiásticas y a la administración, en algunos casos como el del
            Monasterio de Retuerta ha sido la iniciativa privada empresarial la
            que ha sabido poner en valor el patrimonio histórico, salvando a
            este importante monumento de la destrucción que padecieron otros
            muchos.
          </Text>

          <img src="/images/descubra-3.png" />

          <Text>
            Disperso está su patrimonio escultórico o pictórico aunque no
            perdido, pues hoy se pueden admirar en otros emplazamientos. La
            fachada muestra una ampliación de la loggia sur del claustro, que es
            la Hospedería. Por encima la espadaña – campanario se sitúa junto a
            la cabecera de la iglesia. Data de los años 1655-1656.
          </Text>
          <Text>
            La iglesia, que tiene función de apostolado (espadaña), conserva una
            planta irregular. Destaca el cabecero de estilo románico frente a
            partes construidas en etapas posteriores, que se ubican en el gótico
            septentrional. También merecen una reseña individual el claustro, la
            sala capitular y el refectorio.
          </Text>
          <Text>
            El claustro situado en lado sur de la iglesia articula las
            dependencias donde encontramos el refectorio, ubicado de forma
            paralela a la panda del claustro, y no perpendicular como en los
            monasterios cistercienses.
          </Text>
        </>
      )}
    </div>
  );
};

export default Historia;
